import { engineName } from 'react-device-detect';

/**
 * True when the user agent's engine is WebKit, whatever the browser name.
 * A function so suites can mock it; the engine itself is parsed at import.
 */
export const isWebKitEngine = (): boolean => engineName === 'WebKit';
